import { toastController } from '@ionic/vue'

export default async function (message: string) {
  const toast = await toastController.create({ message, duration: 2000 })
  return toast.present()
}
